module.exports = __webpack_public_path__ + "static/bg01-c3dfb02543d518a117852cae2ab803af.jpg";